module.exports = __webpack_public_path__ + "img/bianpao_des_3.f76de321.jpg";